import React, { Fragment } from 'react';
import { FaCaretLeft, FaCaretRight } from 'react-icons/fa';
import { GiGears } from 'react-icons/gi';
import { MdClear, MdEmail } from 'react-icons/md';
import { Container, Form, Row, Col } from 'reactstrap';
import { ArcaHttpWalkplan } from '../../code/ArcaHttpWalkplan';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaDate } from '../../code/Types/ArcaDate';
import { ArcaLink } from '../controls/Fields/ArcaLink';
import { PlanningFullPage } from '../controls/Planning/PlanningFullPage';
import { LoginPanel } from '../controls/Security/LoginPanel';
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';
import { ArcaHttpSystem } from '../../code/ArcaHttpSystem';

export class Planning extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'FullPage',
            today: new ArcaDate(new Date()),
            referenceDate: new ArcaDate(new Date()),
            plan: null,
            statusText: null,
            isError: false,
            updateText: 'The page is loading..',
            gotCalendars: false,
            isLoading: true,
            popupOpen: false,
            showButtonText: true,
            showButtonImage: !ArcaHttpSystem.IsSmartphone,
            walkers: [],
            iconHeight: '25px',
            widthWide: ArcaHttpSystem.IsSmartphone ? '33%' : '25%',
            iconWidth: ArcaHttpSystem.IsSmartphone ? '50%' : '30%',
        };
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize() {
        this.setState({
            showButtonText: true,
            showButtonImage: !ArcaHttpSystem.IsSmartphone,
            widthWide: ArcaHttpSystem.IsSmartphone ? '33%' : '25%',
            iconWidth: ArcaHttpSystem.IsSmartphone ? '50%' : '30%',
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.getScreenDetails(this.state.referenceDate)
    }

    getScreenDetails(referenceDate) {
        ArcaHttpWalkplan.GetDayPlanAsync(
            referenceDate,
            ((plan) => this.setState({
                plan: plan,
                referenceDate
            })),
            ((err) => this.setState({ isError: true, statusText: err })))
    }

    async createPlanAsync(date) {
        await ArcaHttpWalkplan.CreatePlanAsync(
            date,
            ((plan) => this.setState({ plan })),
            ((status) => alert(`CreatePlanAsync failed with status ${status}`)));
    }

    async clearDay(date) {
        await ArcaHttpWalkplan.ClearDayAsync(
            date,
            ((plan) => this.setState({ plan })),
            ((status) => alert(`ClearDayAsync failed with status ${status}`)));
    }

    async setNextDay() {
        await this.getScreenDetails(this.state.referenceDate.AddDay(1))
    }

    async setPreviousDay() {
        await this.getScreenDetails(this.state.referenceDate.AddDay(-1))
    }

    async refreshPage() {
        await this.getScreenDetails(this.state.referenceDate)
    }

    sendEmailSummary(date, walkerId) {
        ArcaHttpWalkplan.EmailWalkerPlansAsync(date,
            (() => this.setState({
                statusText: 'Email sent successfully',
                isError: false
            })),
            (err => this.setState({
                statusText: err,
                isError: true
            }))
        );
    }

    handleDateChange(e) {
        this.getScreenDetails(new ArcaDate(new Date(e.target.value)))
    }

    render() {
        let { referenceDate, today, walkers, plan, showButtonImage, showButtonText, iconHeight, widthWide, iconWidth } = this.state;


        return (
            <Fragment>
                {!ArcaSecurity.IsLoggedIn
                    ? <LoginPanel onLogon={(() => alert("Not logged in"))} />
                    : <Form>
                        <h1 className='centerText'>
                            Planning {referenceDate.DayOfWeek}

                        </h1>
                        <h3 className='centerText'><input id='MyDate' type='date' value={referenceDate.ToISODateString} onChange={(e) => this.handleDateChange(e)} /></h3>

                        <StatusBar
                            isError={this.state.isError}
                            message={this.state.statusText} />

                        {this.props.isLoading
                            ? null
                            : <Fragment>
                                <Container>
                                    <Row>
                                        <Col>
                                            <div className='centerText'>
                                                {referenceDate.IsFuture
                                                    ? <ArcaLink
                                                        icon={showButtonImage ? <GiGears size={iconHeight} color='$colour-primary' /> : null}
                                                        text={showButtonText ? 'Auto' : null}
                                                        colour="primary"
                                                        width={widthWide}
                                                        onClick={this.createPlanAsync.bind(this, referenceDate)} />
                                                    : null}
                                                {referenceDate.IsFuture
                                                    ? <ArcaLink
                                                        icon={showButtonImage ? <MdClear size={iconHeight} color='$colour-primary' /> : null}
                                                        text={showButtonText ? 'Clear' : null}
                                                        colour="secondary"
                                                        width={widthWide}
                                                        onClick={this.clearDay.bind(this, referenceDate)} />
                                                    : null}
                                                <ArcaLink
                                                    icon={showButtonImage ? <MdEmail size={iconHeight} color='$colour-primary' /> : null}
                                                    text={showButtonText ? 'Send' : null}
                                                    colour="secondary"
                                                    width={widthWide}
                                                    onClick={this.sendEmailSummary.bind(this, referenceDate)} />
                                            </div>
                                            <hr />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className='centerText'>
                                                <ArcaLink
                                                    text={showButtonText ? 'Previous' : null}
                                                    icon={showButtonImage ? <FaCaretLeft size={iconHeight} color='$colour-primary' /> : null}
                                                    colour="secondary"
                                                    width={iconWidth}
                                                    onClick={this.setPreviousDay.bind(this)} />
                                                <ArcaLink
                                                    postIcon={showButtonImage ? <FaCaretRight size={iconHeight} color='$colour-primary' /> : null}
                                                    text={showButtonText ? 'Next' : null}
                                                    colour="secondary"
                                                    width={iconWidth}
                                                    onClick={this.setNextDay.bind(this)} />
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>


                                <PlanningFullPage
                                    walkers={walkers}
                                    plan={plan}
                                    today={today}
                                    referenceDate={referenceDate}
                                    needsRefresh={this.refreshPage.bind(this)}
                                    history={this.props.history}
                                />

                            </Fragment>}

                    </Form>}
            </Fragment>
        );
    }

    toggle(tab) {
        this.setState({ activeTab: tab });
    }
}